import { API } from 'classes/api'

if (!window.api5D) {
  window.api5D = new API()
}

const api = window.api5D || new API()

export default api
